var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"firstpage"},[_vm._v(" 第一屏 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }